import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, NavLink } from 'react-router-dom'
import { getTranslate } from 'react-localize-redux';

import styles from './Menu.scss';
import { Modal, Icon, ActionsNav, PageTitle, Spacer } from 'components'
import * as actionCreators from '../../../_store/actions/index';
import {toastr} from 'react-redux-toastr'


class Menu extends Component {
    componentDidUpdate() {
		if(this.props.auth.error) {
            toastr.error("Internal server error", "We're sorry, but an error occurred");
		}
	}

    render () {
        if(this.props.state.open) {
            return (
                <Modal blurClicked={this.props.onCloseMenu}>
                    <div className={styles.menu}>
                        <ActionsNav inModal="true">
                          <a onClick={this.props.onCloseMenu}><Icon type="image" content="close" size="16px"/></a>
                        </ActionsNav>
                        <Link className={styles.item__fullWidth + ' ' + styles.isHiddenDesktop} to="/jobs" onClick={this.props.onCloseMenu}>
                            {this.props.translate('menu.jobs')}
                        </Link>
                        <Link className={styles.item__fullWidth + ' ' + styles.isHiddenDesktop} to="/machines" onClick={this.props.onCloseMenu}>
                            {this.props.translate('menu.machines')}
                        </Link>
                        <a href={this.props.translate('menu.help_link')} target="_blank" className={styles.item__fullWidth + ' ' + styles.isHiddenDesktop} onClick={this.props.onCloseMenu}>
                            {this.props.translate('menu.help')}
                        </a>
                        <h1 className={styles.isHiddenDesktop}>{this.props.translate('menu.title')}</h1>
                        <Link className={styles.item} to="/settings/jobpresets" onClick={this.props.onCloseMenu}>
                            <div>
                                <Icon type="image" content="menusettings" size="41px" display="inline" /><br />
                                {this.props.translate('menu.job_presets')}
                            </div>
                        </Link>
                        <Link className={styles.item} to="/settings/company" onClick={this.props.onCloseMenu}>
                            <div>
                                <Icon type="image" content="company" size="41px" display="inline" /><br />
                                {this.props.translate('menu.company')}
                            </div>
                        </Link>
                    </div>

                </Modal>
            )
        }
        else {
            return(null)
        }
    }
}

const mapStateToProps = state => {
    return {
        state: state.helpersMenu,
        auth: state.auth,
        translate: getTranslate(state.locale)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onCloseMenu: () => dispatch(actionCreators.helpersMenuClose())
    }
};
export default connect(mapStateToProps,mapDispatchToProps)(Menu);



// WEBPACK FOOTER //
// ./src/components/organisms/Menu/index.js